// ─── ALQOS™ Gestor de Usuarios ────────────────────────────────
import { supabase } from "./supabase";
const STORAGE_USUARIOS = 'alqos_usuarios';
const STORAGE_PERMISOS = 'alqos_permisos_modulos';
const BUCKET_LOGOS = 'logos-empresa';
// Cachea el logo de empresa como data URL base64 + su relación de aspecto
// (ancho/alto), para que los generadores de PDF (BotonInstructivo.js,
// IngresoMateriales.js, StockMateriales.js) lo dibujen sincrónico sin tener
// que hacer fetch en medio del armado del PDF -- mismo motivo por el que
// alqos_empresa se cachea en localStorage en vez de pasarse por props.
async function cachearLogoEmpresa(logoPath) {
  if (!logoPath) {
    localStorage.removeItem("alqos_logo_empresa");
    localStorage.removeItem("alqos_logo_ratio");
    return;
  }
  try {
    const { data, error } = await supabase.storage.from(BUCKET_LOGOS).createSignedUrl(logoPath, 3600);
    if (error || !data?.signedUrl) return;
    const resp = await fetch(data.signedUrl);
    const blob = await resp.blob();
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    const dims = await new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve({ w: img.naturalWidth, h: img.naturalHeight });
      img.onerror = () => resolve(null);
      img.src = dataUrl;
    });
    localStorage.setItem("alqos_logo_empresa", dataUrl);
    if (dims?.w && dims?.h) localStorage.setItem("alqos_logo_ratio", String(dims.w / dims.h));
  } catch (e) {
    console.warn("cachearLogoEmpresa:", e);
  }
}
export const MODULOS = [
  { id:1,  nombre:"Órdenes de Trabajo",       icono:"📋" },
  { id:2,  nombre:"No Conformidades",          icono:"⚠️" },
  { id:3,  nombre:"Documentos",                icono:"📁" },
  { id:4,  nombre:"Familias y Líneas",         icono:"🏭" },
  { id:5,  nombre:"FMEA",                      icono:"🔍" },
  { id:6,  nombre:"Plan de Control",           icono:"✅" },
  { id:7,  nombre:"Capabilidad y MSA",         icono:"📊" },
  { id:8,  nombre:"Dashboard CA",              icono:"🏅" },
  { id:9,  nombre:"Proveedores",               icono:"🤝" },
  { id:10, nombre:"Cotización",                icono:"💰" },
  { id:11, nombre:"Capacitaciones",            icono:"🎓" },
  { id:12, nombre:"Auditorías",                icono:"🔎" },
  { id:13, nombre:"Compras",                   icono:"🛒" },
  { id:14, nombre:"Diseño y Desarrollo",       icono:"✏️" },
  { id:15, nombre:"Producción",                icono:"🏗️" },
  { id:16, nombre:"Recursos Humanos",          icono:"👥" },
  { id:17, nombre:"Ventas",                    icono:"📈" },
  { id:18, nombre:"Pre Prensa",                icono:"🖨️" },
  { id:19, nombre:"Oficina Técnica",           icono:"📐" },
  { id:20, nombre:"Clientes",                  icono:"🤝" },
  { id:21, nombre:"Especificaciones Técnicas", icono:"📌" },
  { id:22, nombre:"Higiene y Seguridad",       icono:"🦺" },
  { id:23, nombre:"TPM Mantenimiento",         icono:"🔧" },
  { id:24, nombre:"Comercio Exterior",         icono:"🌐" },
  { id:25, nombre:"ARIA — IA",                 icono:"🤖" },
  { id:26, nombre:"Usuarios",                  icono:"👥" },
  { id:27, nombre:"Acciones Correctivas",      icono:"🔁" },
  { id:28, nombre:"FSC Arqueo",                icono:"🌿" },
  { id:29, nombre:"Importar CSV",              icono:"📥" },
  { id:30, nombre:"Ciberseguridad",            icono:"🔐" },
  { id:31, nombre:"Sustentabilidad y MA",      icono:"🌍" },
  { id:32, nombre:"Análisis de Causa",         icono:"🔬" },
  { id:33, nombre:"Programa Auditorías",       icono:"📅" },
  { id:34, nombre:"Assured Quality",           icono:"🏆" },
  { id:35, nombre:"Ingreso de Materiales",     icono:"📦" },
  { id:36, nombre:"Huella de Carbono",         icono:"🌱" },
  { id:37, nombre:"HACCP",                     icono:"🧫" },
  { id:38, nombre:"POEs",                      icono:"📄" },
  { id:39, nombre:"Stock Materiales",          icono:"📦" },
  { id:40, nombre:"Trazabilidad",               icono:"🔗" },
  { id:41, nombre:"Despacho",                   icono:"📦" },
  { id:43, nombre:"Costos de No Calidad",       icono:"💸" },
  { id:44, nombre:"Instructivos ALQOS™",        icono:"📖" },
  { id:45, nombre:"Cumplimiento de Normas",     icono:"📋" },
  { id:46, nombre:"Comunicados Internos",       icono:"📢" },
  { id:47, nombre:"Onboarding",                 icono:"🚀" },
  { id:48, nombre:"Escritorio Calidad",         icono:"🗂️" },
  { id:49, nombre:"ALQOS Asesor",                icono:"🔍" },
  { id:50, nombre:"Mapa de Procesos ALQOS™",     icono:"🗺️" },
  { id:51, nombre:"Centros de Costo",             icono:"⚙️" },
  { id:52, nombre:"Motor de Costeo",               icono:"🧮" },
  { id:53, nombre:"LegalMatrix Engine",             icono:"⚖️" },
  { id:54, nombre:"Plan de Cuentas",          icono:"📒" },
  { id:55, nombre:"Asientos Contables",       icono:"📑" },
  { id:56, nombre:"Cuentas por Cobrar/Pagar", icono:"💳" },
  { id:57, nombre:"Movimientos de Caja",      icono:"🏦" },
  { id:58, nombre:"Finanzas",                 icono:"💰" },
  { id:59, nombre:"Balance", icono:"📊" },
  { id:60, nombre:"Máquinas", icono:"⚙️" },
  { id:61, nombre:"Auditoría y Trazabilidad", icono:"🕵️" },
  { id:62, nombre:"Control de Calidad de Piso", icono:"📋" },
  { id:63, nombre:"Ética y RSE", icono:"🕊️" }
];
export const ROLES = {
  Administrador: {
    label: "👑 Administrador",
    color: "#7B5BF2",
    descripcion: "Acceso total al sistema",
    permisos: ["todo"],
    modulosVisibles: "todos",
  },
  Calidad: {
    label: "🏅 Calidad",
    color: "#3b82f6",
    descripcion: "NC, FMEA, Plan de Control, Auditorías, Acciones Correctivas, FSC",
    permisos: ["leer", "crear", "editar"],
    modulosVisibles: [2,5,6,7,8,12,27,28,32,33,35,37,38,39,60,61,62,63],
  },
  Auditor: {
    label: "🔎 Auditor",
    color: "#f59e0b",
    descripcion: "Solo lectura en todos los módulos de calidad",
    permisos: ["leer"],
    modulosVisibles: [2,5,6,8,12,27,28,37,38,62,63],
  },
  Produccion: {
    label: "🏗️ Producción",
    color: "#22c55e",
    descripcion: "OT, Producción, Pre Prensa, Oficina Técnica",
    permisos: ["leer", "crear", "editar"],
    modulosVisibles: [1,6,15,18,19,35,39,60],
  },
  Compras: {
    label: "🛒 Compras",
    color: "#f59e0b",
    descripcion: "Aprueba y gestiona Órdenes de Compra, Proveedores, Stock",
    permisos: ["leer", "crear", "editar"],
    modulosVisibles: [9,13,35,39,41],
  },
  Direccion: {
    label: "📊 Dirección",
    color: "#09184D",
    descripcion: "Dashboard CA y reportes, solo lectura",
    permisos: ["leer"],
    modulosVisibles: [2,5,8,12,27,28,34,36,63],
  },
  SoloLectura: {
    label: "👁 Solo lectura",
    color: "#808085",
    descripcion: "Acceso de visualización únicamente",
    permisos: ["leer"],
    modulosVisibles: [2,8],
  },
  Empleado: {
    label: "👤 Empleado",
    color: "#22c55e",
    descripcion: "Portal personal: recibos, documentos y certificados",
    permisos: ["leer"],
    modulosVisibles: [],
  },
};
// Semilla local mínima usada solo como placeholder antes del primer sync con
// Supabase (autenticarSupabase() es el único mecanismo real de login -- ver
// más abajo). Nunca contiene una contraseña: el login real siempre pasa por
// Supabase Auth, nunca por comparación local.
const USUARIOS_DEFAULT = [{
  id: 1,
  nombre: "Adriana",
  email: "admin@alqos.com",
  rol: "Administrador",
  empresa: "ALQOS™",
  activo: true,
  fechaCreacion: new Date().toISOString(),
  creadoPor: "Sistema",
}];
// ─── LOCAL STORAGE ────────────────────────────────────────────
export function getUsuarios() {
  try {
    const raw = localStorage.getItem(STORAGE_USUARIOS);
    if (!raw) { localStorage.setItem(STORAGE_USUARIOS, JSON.stringify(USUARIOS_DEFAULT)); return USUARIOS_DEFAULT; }
    return JSON.parse(raw);
  } catch { return USUARIOS_DEFAULT; }
}
export function setUsuarios(usuarios) {
  try { localStorage.setItem(STORAGE_USUARIOS, JSON.stringify(usuarios)); return true; }
  catch { return false; }
}
export function getPermisosLocales() {
  try { return JSON.parse(localStorage.getItem(STORAGE_PERMISOS) || "{}"); }
  catch { return {}; }
}
export function setPermisosLocales(permisos) {
  try { localStorage.setItem(STORAGE_PERMISOS, JSON.stringify(permisos)); return true; }
  catch { return false; }
}
// ─── SUPABASE SYNC ────────────────────────────────────────────
export async function syncUsuariosDesdeSupabase() {
  try {
    const { data, error } = await supabase.from("usuarios").select("*");
    if (error || !data?.length) return;
    // Confiar directo en Supabase (ya filtrado por tenant vía RLS) -- no mezclar con
    // localStorage. Un usuario nuevo siempre se crea vía /api/crear-usuario, que escribe
    // a Supabase antes de devolver éxito, así que nunca hay un caso real de "usuario
    // solo local todavía no sincronizado". Mezclar acá permitía que apareciera el
    // usuario placeholder (USUARIOS_DEFAULT) o datos viejos de otra sesión/tenant en
    // este mismo navegador.
    setUsuarios(data);
  } catch(e) { console.warn("syncUsuarios:", e); }
}
export async function syncPermisosDesdeSupabase() {
  try {
    const { data, error } = await supabase.from("permisos_modulos").select("*");
    if (error) { console.warn("syncPermisos: error de red, se mantiene caché local", error); return; }
    const mapa = {};
    (data || []).forEach(p => {
      if (!mapa[p.usuario_id]) mapa[p.usuario_id] = {};
      mapa[p.usuario_id][p.modulo] = p.habilitado;
    });
    setPermisosLocales(mapa);
  } catch(e) { console.warn("syncPermisos:", e); }
}
export async function guardarUsuarioSupabase(usuario) {
  try {
    const { password, ...sinPass } = usuario;
    // tenant_id explícito -- no asumir que siempre llega en `usuario` (hoy
    // así es, porque el único caller parte de una fila ya sincronizada de
    // Supabase, pero no está garantizado por la firma de la función).
    const { error } = await supabase.from("usuarios").upsert({...sinPass, celular: usuario.celular||"", tenant_id: usuario.tenant_id}, { onConflict: "id" });
    if (error) console.warn("guardarUsuario:", error);
  } catch(e) { console.warn(e); }
}
// ─── PERMISOS DE PESTAÑA — módulo 49 (Portal Asesores) ────────
const TABS_CONSULTOR_HS = ["visitas","perfil","normativas","hallazgos","normaria","aspectos","programa"];
export function getTabsConsultorHS(permisosCustom, rol) {
  // Mismo criterio que modulosBase en autenticarSupabase(): sin fila
  // personalizada en permisos_modulos, un rol con acceso "todos" (hoy
  // Administrador) ve todas las pestañas por default. El fail-closed de
  // fb419e9 sigue aplicando cuando sí hay permisosCustom guardado, o para
  // roles sin "todos" (el caso real que motivó ese fix: asesores externos
  // del módulo 49).
  const todoPorDefault = !permisosCustom && ROLES[rol]?.modulosVisibles === "todos";
  const result = {};
  TABS_CONSULTOR_HS.forEach(tab => {
    result[tab] = permisosCustom?.[`49_tab_${tab}`] ?? todoPorDefault;
  });
  return result;
}
export async function guardarPermisosSupabase(usuarioId, modulosHabilitados, tabsConsultorHS49 = null) {
  try {
    // Tenant del admin que actúa -- coincide con el del usuario objetivo
    // porque la API (gestionar-usuario/crear-usuario) solo deja administrar
    // usuarios del propio tenant.
    const tenantId = Number(localStorage.getItem("alqos_tenant_id")) || null;
    const rows = MODULOS.map(m => ({
      usuario_id: usuarioId,
      modulo: String(m.id),
      habilitado: modulosHabilitados.includes(m.id),
      tenant_id: tenantId,
    }));
    if (tabsConsultorHS49) {
      TABS_CONSULTOR_HS.forEach(tab => {
        rows.push({ usuario_id: usuarioId, modulo: `49_tab_${tab}`, habilitado: tabsConsultorHS49[tab] ?? false, tenant_id: tenantId });
      });
    }
    const { error } = await supabase.from("permisos_modulos").upsert(rows, { onConflict: "usuario_id,modulo" });
    if (error) console.warn("guardarPermisos:", error);
  } catch(e) { console.warn(e); }
}
// ─── AUTH (Supabase) ──────────────────────────────────────────
// Único mecanismo de login real de ALQOS -- confirmado por grep en todo el
// proyecto que App.js solo importa/llama autenticarSupabase(), nunca una
// comparación de contraseña en texto plano en el cliente.
export async function autenticarSupabase(email, password) {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error || !data?.user) return { error: "Usuario o contraseña incorrectos" };
    return await construirUsuarioDesdeAuthId(data.user.id);
  } catch (e) {
    console.error("autenticarSupabase:", e);
    return { error: "Error de conexión. Intentá de nuevo." };
  }
}
// Reconstruye el mismo objeto `usuario` que autenticarSupabase(), pero a
// partir de una sesión de Supabase ya activa (sin email/password). La usa
// autenticarSupabase() en el login manual y autenticarSupabaseDesdeSesion()
// para restaurar sesión al montar la app (incluye el caso de impersonación,
// que deja una sesión válida vía verifyOtp sin pasar por signInWithPassword).
export async function construirUsuarioDesdeAuthId(authId) {
    const { data: perfil, error: perfilError } = await supabase
      .from("usuarios")
      .select("*")
      .eq("auth_id", authId)
      .single();
    if (perfilError || !perfil) {
      return { error: "Usuario autenticado pero sin perfil asociado. Contactá al administrador." };
    }
    if (!perfil.activo) {
      return { error: "Usuario inactivo. Contactá al administrador." };
    }
    // Fase A multi-tenant: guardar el tenant_id en localStorage para que
    // syncSupabase.js lo use al subir datos (subirDatos/subirDatosSingle),
    // sin tener que cambiar la firma de esas funciones ni los ~58 módulos
    // que las llaman.
    if (perfil.tenant_id) {
      localStorage.setItem("alqos_tenant_id", String(perfil.tenant_id));
    }
    // Cacheado para branding de documentos (rótulos, PDF de instructivos)
    // que se generan fuera del árbol de componentes de App.js y no reciben
    // `usuario` como prop -- mismo criterio que alqos_tenant_id de arriba,
    // para no tener que prop-dril este dato en cada call site.
    localStorage.setItem("alqos_empresa", perfil.empresa || "");
    localStorage.setItem("alqos_empresa_direccion", perfil.empresa_direccion || "");
    localStorage.setItem("alqos_empresa_cuit", perfil.empresa_cuit || "");
    await cachearLogoEmpresa(perfil.logo_url);
    const permisosLocales = getPermisosLocales();
    const permisosCustom = permisosLocales[perfil.id];
    const modulosBase = ROLES[perfil.rol]?.modulosVisibles || "todos";
    // Fase D — control de acceso por plan: si plan_modulos no tiene filas
    // para el plan del tenant (plan "Full" hoy, sin datos cargados) o la
    // query falla, no restringe nada -- el filtro real arranca recién
    // cuando Fase D2 cargue filas. modulo_key usa el mismo id numérico de
    // MODULOS (como texto), no el slug de MODULOS_ALQOS (Instructivos).
    let modulosPlan = null; // null = sin restricción de plan
    if (perfil.tenant_id) {
      const { data: tenantPlan, error: tenantPlanError } = await supabase
        .from("tenants")
        .select("plan_id")
        .eq("id", perfil.tenant_id)
        .single();
      if (tenantPlanError) {
        console.warn("Fase D — no se pudo resolver plan_id del tenant:", tenantPlanError);
      } else if (tenantPlan?.plan_id) {
        const { data: planModulos, error: planModulosError } = await supabase
          .from("plan_modulos")
          .select("modulo_key")
          .eq("plan_id", tenantPlan.plan_id)
          .eq("habilitado", true);
        if (planModulosError) {
          console.warn("Fase D — no se pudo resolver plan_modulos:", planModulosError);
       } else if (planModulos?.length > 0) {
          modulosPlan = new Set(planModulos.map(p => String(p.modulo_key)));
        }
      }
      // Fase D2 — excepciones puntuales por tenant (módulo suelto fuera del
      // plan, ej. un cliente "Esencial" con un módulo extra de Profesional
      // habilitado a mano). Solo aplica si modulosPlan ya es un set real —
      // si el plan todavía no tiene filas cargadas, no hay restricción que
      // ampliar.
      if (modulosPlan) {
        const { data: extras, error: extrasError } = await supabase
          .from("tenant_modulos_extra")
          .select("modulo_id")
          .eq("tenant_id", perfil.tenant_id);
        if (extrasError) {
          console.warn("Fase D2 — no se pudo resolver tenant_modulos_extra:", extrasError);
        } else {
          (extras || []).forEach(e => modulosPlan.add(String(e.modulo_id)));
        }
      }
    }
    // Administrador ignora permisos_modulos por completo: un override viejo
    // (guardado antes de que existiera un módulo nuevo) no debe poder dejar
    // a un Administrador sin acceso a ese módulo. Los demás roles siguen
    // respetando el override normalmente.
    let modulosVisibles = perfil.rol === "Administrador"
      ? "todos"
      : (permisosCustom
          ? MODULOS.filter(m => permisosCustom[String(m.id)] === true).map(m => m.id)
          : modulosBase);
    if (modulosPlan) {
      modulosVisibles = (modulosVisibles === "todos" ? MODULOS.map(m => m.id) : modulosVisibles)
        .filter(id => modulosPlan.has(String(id)));
    }
    // Buscar organizaciones asignadas a este usuario
    const { data: orgsData } = await supabase
      .from("usuario_organizaciones")
      .select("organizacion_id, rol_en_org, organizaciones(nombre, estado)")
      .eq("usuario_id", perfil.id);
    return {
      usuario: {
        id: perfil.id,
        nombre: perfil.nombre,
        email: perfil.email,
        rol: perfil.rol,
        empresa: perfil.empresa,
        empresa_direccion: perfil.empresa_direccion || '',
        empresa_cuit: perfil.empresa_cuit || '',
        tenant_id: perfil.tenant_id,
        modulosVisibles,
        permisos: ROLES[perfil.rol]?.permisos || ["leer"],
        tabsConsultorHS: getTabsConsultorHS(permisosCustom, perfil.rol),
        organizaciones: orgsData || [],
        esAsesorCliente: (orgsData || []).length > 0,
      }
    };
}
// Restaura `usuario` a partir de una sesión de Supabase ya activa (ej. al
// recargar la página, o después de un verifyOtp de impersonación que no
// pasa por signInWithPassword). Mismo criterio de perfil/permisos que
// autenticarSupabase(), vía construirUsuarioDesdeAuthId().
export async function autenticarSupabaseDesdeSesion() {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) return { error: "No hay sesión activa." };
    return await construirUsuarioDesdeAuthId(session.user.id);
  } catch (e) {
    console.error("autenticarSupabaseDesdeSesion:", e);
    return { error: "Error de conexión. Intentá de nuevo." };
  }
}
// ─── HELPERS ──────────────────────────────────────────────────
export function puedeVer(usuario, moduloId) {
  if (!usuario) return false;
  const vis = usuario.modulosVisibles;
  if (vis === "todos") return true;
  return Array.isArray(vis) && vis.includes(moduloId);
}
export function puedeEditar(usuario) {
  if (!usuario) return false;
  return usuario.permisos?.includes("todo") || usuario.permisos?.includes("editar");
}
export function puedeCrear(usuario) {
  if (!usuario) return false;
  return usuario.permisos?.includes("todo") || usuario.permisos?.includes("crear");
}
export function esAdmin(usuario) {
  return usuario?.rol === "Administrador";
}
